module.exports = __webpack_public_path__ + "img/tianjianhu.c05a0744.png";